import { CalendarDate } from "../../../lib/helpers/hooks/useCalendarDays";
import AscDatePickerDayView from "../AscCalendarDayView/AscCalendarDayView";
import styles from "./AscCalendarMonthView.module.scss";

interface AscCalendarMonthViewProps {
  calendarDaysForMonth: CalendarDate[];
  weekdayLabels: string[];
  onDayClick: (day: CalendarDate) => void;
}

export default function AscCalendarMonthView({
  calendarDaysForMonth,
  weekdayLabels,
  onDayClick,
}: AscCalendarMonthViewProps) {
  return (
    <div className={styles.ground}>
      <div className={styles.weekDaysContainer}>
        {weekdayLabels.map((dayLabel) => (
          <div className={styles.dayLabel} key={dayLabel}>
            {dayLabel}
          </div>
        ))}
      </div>
      <div className={styles.daysContainer}>
        {calendarDaysForMonth.map((day) => {
          return (
            <AscDatePickerDayView
              date={day?.date}
              activeMonth={day?.flag === "activeMonth"}
              key={day?.date.toString()}
              events={day?.events}
              dayLabel={day?.date?.getDate()?.toString()}
              onDayClick={onDayClick}
            />
          );
        })}
      </div>
    </div>
  );
}
